<template>
  <div class="main">
    <div class="scroll-box" ref="scrollBox">
      <main class="content">
        <van-grid :column-num="2" :gutter="5" :border="false" v-if="imgList.length">
          <van-grid-item class="grid-item" v-for="item in imgList" :key="item.posterId">
            <div class="img-box">
              <van-image
                width="100%"
                height="auto"
                fit="contain"
                :src="item.imgUrl"
              />
            </div>
            <div class="btn-box">
              <van-button class="download-btn" block plain size="small" color="#FF6B31" @click="download(item)">下载海报</van-button>
              <van-button class="download-btn" block plain size="small" color="#FF6B31" @click="download(item, true)">下载二维码</van-button>
            </div>
          
          </van-grid-item>
        </van-grid>
        <div class="no-data" v-else>
          <van-image width="170px" height="auto" fit="fill" :src="noDataImg" />
          <div>暂无数据</div>
        </div>
      </main>
    </div>
    <!-- <footer>
      <div class="footer-btn plain" @click="goBack">返回</div>
    </footer> -->

    <download-poster 
      v-if="isShowDialog" 
      :visible.sync="isShowDialog" 
      :posterData="posterData"
     />
  </div>
</template>

<script>
import DownloadPoster from './components/download-poster-dialog'
import loadingMixin from '@/mixins/loading-mixin'
import { mapGetters } from 'vuex'
import {mini_env_version} from '@/utils/constant'
export default {
  name: 'PromotionPoster',
  mixins: [loadingMixin],
  components: {
    DownloadPoster
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  data() {
    return {
      noDataImg: require('@/assets/images/img-default@2x.png'),
      imgList: [],
      loading: null,
      isShowDialog: false,
      posterData: {},
    }
  },
  methods: {
    init() {
      if (!this.$route.query.activityId) {
        return;
      }

      this.showLoading();
      this.$api.activityMgmt.getPostersById(this.$route.query.activityId)
        .then(({data}) => {
          this.imgList = data.activityPoster
            && data.activityPoster.map(item => ({
              posterId: item.posterId,
              imgUrl: item.imgUrl
            }))
            || [];
        })
        .finally(_ => {
          this.hideLoading();
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    download(poster,isBackImg = '') {
      const shareInfo = {
        activityId: this.$route.query.activityId,
        h5UserId: this.userInfo.id
      };
      const params = {
        activityId: this.$route.query.activityId,
        inviteParams: JSON.stringify(shareInfo)
      };
      this.$api.activityMgmt.getShareScene(params)
        .then(({data}) => {
          if (!data) {
            return;
          }
          this.posterData = {
            imageUrl: poster.imgUrl,
            scene: data,
            page: 'pages/index/index',
            env_version: mini_env_version,
            notImage: isBackImg
          };
          this.isShowDialog = true;
        });
    }
  },
  created() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.main
  .scroll-box
    // height: calc(100vh - 64px)
    height: 100vh
    overflow-y auto
    &::-webkit-scrollbar
      display: none
    .content
      padding 10px 5px

  .img-box
    box-sizing: border-box
    position relative
    width 155px
    height: 220px
    border-radius: 6px
    background-color: #f0f0f0
    overflow hidden
  .btn-box
    display: flex;
    width: 100%;
  .grid-item
    .download-btn
      margin-top 15px
      border-radius 6px
      margin-right: 2px;
    .download-btn:last-child {
      margin-right: 0;
    }
    >>> .van-grid-item__content
      padding 8px 8px 0
      background: transparent
  
  .no-data
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    color #BBBBBB
    font-size 14px
    height 60vh
    line-height: 2
    
  footer
    box-sizing: border-box
    position fixed
    left 0
    bottom 0
    z-index 999
    padding 0 10px
    height 64px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    background-color #fff

    .footer-btn
      padding 10px 50px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    .footer-btn-s
      padding 10px 15px
    .plain
      color $mainTextColor
      background-color: #fff

</style>
